// window.addEventListener('DOMContentLoaded', function () {
const textareas = document.querySelectorAll('.form-textarea__textarea');
if (textareas.length > 0) {
    textareas.forEach(textarea => {
        textarea.addEventListener('input', function () {
            console.log(textarea.value.trim());
            if (textarea.value.trim() !== '') {
                textarea.classList.add('has-content');
            } else {
                textarea.classList.remove('has-content');
            }
        });

        if (textarea.value.trim() !== '') {
            textarea.classList.add('has-content');
        }
    });
}

// });
